{
  "captchaHint": "請輸入驗證碼以開始撥號",
  "verify": "驗證",
  "invalidCaptcha": "驗證碼錯誤，請重新輸入",
  "expiresIn": "剩餘時間",
  "expiredHint": "授權已過期，請重新驗證",
  "browser": {
    "title": "注意事項",
    "versionHint": "請使用瀏覽器 Chrome 72、Edge 79、Firefox 65 或 Safari 12 以上版本，以避免無法正常操作。",
    "unsupportedHint": "此瀏覽器不支援通話所需功能,請改用 Chrome、Edge、Firefox 或 Safari 的較新版本。",
    "insecureHint": "請以 https 安全連線開啟本頁,才能正常使用通話功能。"
  }
}